import React from 'react';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { useCheckoutContext } from '../../../../CheckoutProvider';
import { CheckoutPaymentBlockPromoCodeWithoutSeparateGiftCard } from './CheckoutPaymentBlockPromoCodeWithoutSeparateGiftCard';
import { CheckoutPaymentBlockPromoCodeWithSeparateGiftCard } from './CheckoutPaymentBlockPromoCodeWithSeparateGiftCard';

export const ConnectedCheckoutPaymentBlockPromoCode = () => {
  const context = useCheckoutContext();

  const shouldSeparatePromoAndGiftCard = useFeatureFlag(
    'CELS-1410-separate-promo-and-gift-card',
  );

  if (shouldSeparatePromoAndGiftCard) {
    return <CheckoutPaymentBlockPromoCodeWithSeparateGiftCard {...context} />;
  }

  return <CheckoutPaymentBlockPromoCodeWithoutSeparateGiftCard {...context} />;
};
